const API_BASE = import.meta.env.VITE_API_URL || "https://ckgo2-api.martin-94d.workers.dev";

interface ApiError {
  error: string;
  message: string;
  success: false;
}

class ApiClient {
  private baseUrl: string;

  constructor(baseUrl: string = API_BASE) {
    this.baseUrl = baseUrl;
  }

  private async request<T>(
    method: string,
    path: string,
    data?: unknown
  ): Promise<T> {
    const url = `${this.baseUrl}${path}`;

    const options: RequestInit = {
      method,
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    };

    if (data) {
      options.body = JSON.stringify(data);
    }

    const response = await fetch(url, options);
    const json = await response.json();

    if (!response.ok) {
      const error = json as ApiError;
      throw new Error(error.message || "Požadavek se nezdařil");
    }

    return json as T;
  }

  async get<T>(path: string): Promise<T> {
    return this.request<T>("GET", path);
  }

  async post<T>(path: string, data?: unknown): Promise<T> {
    return this.request<T>("POST", path, data);
  }

  async put<T>(path: string, data?: unknown): Promise<T> {
    return this.request<T>("PUT", path, data);
  }

  async patch<T>(path: string, data?: unknown): Promise<T> {
    return this.request<T>("PATCH", path, data);
  }

  async delete<T>(path: string, data?: unknown): Promise<T> {
    return this.request<T>("DELETE", path, data);
  }
}

export const api = new ApiClient();

// Typed API hooks helpers
export interface ApiResponse<T> {
  data: T;
  success: true;
}

export interface PaginatedResponse<T> {
  data: T[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
  success: true;
}
